import React, { useState } from 'react';
import './App.css';
import Selector from './components/Selector';
import Results from './components/Results';

export interface GeneratorConfig {
  minRange: number;
  maxRange: number;
  numberCount: number;
  repeatCount: number;
}

function App() {
  const [config, setConfig] = useState<GeneratorConfig>({
    minRange: 1,
    maxRange: 100,
    numberCount: 6,
    repeatCount: 1,
  });

  const [results, setResults] = useState<number[][]>([]);
  const [isGenerated, setIsGenerated] = useState(false);

  const handleConfigChange = (newConfig: Partial<GeneratorConfig>) => {
    setConfig((prev) => ({ ...prev, ...newConfig }));
  };

  const generateNumbers = () => {
    const sets: number[][] = [];
    for (let i = 0; i < config.repeatCount; i++) {
      const set = new Set<number>();
      while (set.size < config.numberCount) {
        const randomNum = Math.floor(
          Math.random() * (config.maxRange - config.minRange + 1) + config.minRange
        );
        set.add(randomNum);
      }
      sets.push(Array.from(set).sort((a, b) => a - b));
    }
    setResults(sets);
    setIsGenerated(true);
  };

  return (
    <div className="app-container">
      <div className="app-wrapper">
        <h1 className="app-title">Generator numerów lotto</h1>
        <Selector config={config} onConfigChange={handleConfigChange} onGenerate={generateNumbers} />
        {isGenerated && <Results sets={results} />}
      </div>
    </div>
  );
}

export default App;
